import {
	Component,
	ViewEncapsulation,
	Input,
	ContentChildren,
	QueryList,
	OnDestroy,
	forwardRef,
	OnInit,
	AfterViewInit
} from "@angular/core";
import { IdService } from "../../shared/services/id.service";
import { StepperContentComponent } from "../stepper-content/stepper-content.component";
import { StepsDataService } from "../stepsData/steps-data.service";
import { StepperComponent } from "../stepper.component";

@Component({
	selector: "rbc-stepper-container",
	templateUrl: "./stepper-container.component.html",
	styles: [],
	providers: [StepsDataService],
	encapsulation: ViewEncapsulation.None
})
export class StepperContainerComponent implements OnDestroy, AfterViewInit {
	@Input() buttonHide = false;
	@Input() buttonNextHide = false;
	@Input() buttonNextText = "Next";
	@Input() buttonPrevHide = false;
	@Input() buttonPrevText = "Previous";
	@Input() id: string;

	currentStepContent: StepperContentComponent;

	// Steps is an immutable query list of stepper content components, to get resulting Step types have to use toArray()
	// @ViewChild(forwardRef(() => StepperComponent))
	@ContentChildren(StepperContentComponent) steps: QueryList<
		StepperContentComponent
	>;
	@ContentChildren(forwardRef(() => StepperComponent)) stepper: QueryList<
		StepperComponent
	>;

	constructor(
		private idService: IdService,
		private stepsDataService: StepsDataService
	) {
		this.id = idService.generate();
	}
	ngAfterViewInit() {
		if (this.stepper.first.followFlow) {
			this.steps.toArray()[this.currentStepIndex].completeProgress(true);
		}
	}
	get currentStepIndex(): number {
		return this.stepsDataService.currentStepIndex;
	}

	set currentStepIndex(index: number) {
		this.stepsDataService.currentStepIndex = index;
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	StepperContainer_next() {
		const newActiveId = this.steps.toArray()[this.currentStepIndex + 1]
			? this.steps.toArray()[this.currentStepIndex + 1].id
			: -1;
		this.steps.toArray()[this.currentStepIndex].active = false;
		this.$_StepperContainer_updateStep(newActiveId);
		if (this.stepper.first.followFlow) {
			// if () { }
			this.steps.toArray()[this.currentStepIndex].completeProgress(true);
			this.steps.toArray()[this.currentStepIndex - 1].completeProgress(true);
			this.steps.toArray()[this.steps.toArray().length - 1].completeProgress(false)
		}
	}

	StepperContainer_prev() {
		const newActiveId = this.steps.toArray()[this.currentStepIndex - 1]
			? this.steps.toArray()[this.currentStepIndex - 1].id
			: -1;
		this.$_StepperContainer_updateStep(newActiveId);
	}

	$_StepperContainer_updateStep(id) {
		if (id !== -1) {
			this.steps.forEach(step => {
				step.disabled = step.id === id ? false : step.disabled;
				step.isActive = step.id === id;
			});
		}
		this.currentStepContent = this.steps.filter(step => step.isActive)[0];
		this.currentStepIndex = this.steps
			.toArray()
			.indexOf(this.currentStepContent);
	}
}
